var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgQuestionMarkIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.49967 17.4154C13.8719 17.4154 17.4163 13.871 17.4163 9.4987C17.4163 5.12644 13.8719 1.58203 9.49967 1.58203C5.12742 1.58203 1.58301 5.12644 1.58301 9.4987C1.58301 13.871 5.12742 17.4154 9.49967 17.4154Z",
    fill: "#DEE2E6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.49995 12.6659C9.93718 12.6659 10.2916 13.0204 10.2916 13.4576C10.2916 13.8948 9.93718 14.2493 9.49995 14.2493C9.06273 14.2493 8.70828 13.8948 8.70828 13.4576C8.70828 13.0204 9.06273 12.6659 9.49995 12.6659ZM9.38199 4.6875C11.3936 4.6875 12.973 6.23362 12.973 8.22862C12.973 10.2236 11.3936 11.7698 9.38199 11.7698H8.38449V10.4564H9.38199C10.6455 10.4564 11.5599 9.49212 11.5599 8.22862C11.5599 6.96512 10.6455 6.00087 9.38199 6.00087C8.10187 6.00087 7.22074 6.96512 7.22074 8.22862H5.80762C5.80762 6.23362 7.37037 4.6875 9.38199 4.6875Z",
    fill: "#6C757D"
  })));
}

export default SvgQuestionMarkIcon;